import { render, staticRenderFns } from "./LabResultPrint.vue?vue&type=template&id=52aed8f7&"
import script from "./LabResultPrint.vue?vue&type=script&lang=js&"
export * from "./LabResultPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports